import { CSSProperties } from 'react';
import styled from 'styled-components';

export const IMG_SIZE = 30;

export const iconStyle: CSSProperties = { marginRight: 6 };
export const style: CSSProperties = { fontSize: '29px' };
export const navItemStyle: CSSProperties = { padding: '0px 20px' };

export const NavWrapper = styled.div`
  display: flex;
  height: auto;
  align-items: center;
  flex-wrap: nowrap;
  border-left: 1px solid #fff;

  @media (max-width: 767px) {
    border-top: 1px solid #fff;
    border-left: none;
  }
`;
